



















































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal de la aplicación
 */
import MainReport from "@/components/Reports/MainReport.vue";
import MainReportSupplier from "@/components/Reports/MainReportSupplier.vue";
// Internacionalización. Para la presentación de mensajes en diferentes idiomas
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos los componentes que utilizará este módulo
    MainReport,
    MainReportSupplier,
  },
  data() {
    return {
      responseDemo: {},
      moduleName: "HOME",
      id: null,
      //AUTORIZADOR
      items: [
        {
          title: "Documentos por Proveedor",
          action: "ic_worker",
          descripcion:
            "Visualiza, Autoriza y Rechaza los documentos pendientes del proveedor",
          link: "/lista-documentos-proveedor",
          key: "docProvAutorizador",
        },
        {
          title: "Documentos de Términos y Condiciones",
          action: "ic_document",
          descripcion:
            "Visualiza, Autoriza y Rechaza los documentos pendientes de los Términos y Condiciones ",
          link: "/lista-terminos-condiciones",
          key: "termCondAutorizador",
        },
        /* {
          title: "Facturas",
          action: "ic_invoice",
          descripcion:
            "Visualiza, Autoriza y Rechaza los documentos por factura por orden de compra",
          link: "/lista-factura",
          key: "docFactAutorizador",
        }, */
         {
          title: "Reportes",
          action: "clipboard-file",
          descripcion:
            "Genera y visualiza los reportes",
          link: "/reportes",
          key: "repAutorizador",
        },
      ],
      //USUARIO PROVEEDOR
      items_Prov: [
        {
          title: "Documentos por Proveedor",
          action: "ic_worker",
          descripcion:
            "Administra tus documentos de alta como proveedor de Subcontratación",
          link: "/proveedor/registro",
          key: "docProveedor",
        },
        {
          title: "Documentos de Términos y Condiciones",
          action: "ic_document",
          descripcion:
            "Administra tus documentos de Términos y Condiciones por orden de compra y sociedad",
          link: "/proveedor/terminos-condiciones",
          key: "termCondProveedor",
        },
        /* {
          title: "Facturas",
          action: "ic_invoice",
          descripcion:
            "Administra tus documentos por factura relacionadas con las ordenes de compra que tiene asignadas y visualiza tus pagos",
          link: "/proveedor/lista-factura",
          key: "docFactProveedor",
        }, */
        {
          title: "Reportes",
          action: "clipboard-file",
          descripcion:
            "Genera y visualiza tus reportes",
          link: "/proveedor/reportes",
          key: "repProveedor",
        },
      ],
      //USUARIO ADMIN / USUARIO DE CONSULTA/ ETC.
      items_Gral: [
        {
          title: "Documentos por Proveedor",
          action: "ic_worker",
          descripcion:
            "Recepción de documentación de alta del proveedor como Subcontratación",
          link: "/lista-documentos-proveedor",
          key: "docProvUsuario",
        },
        {
          title: "Documentos de Términos y Condiciones",
          action: "ic_document",
          descripcion:
            "Recepción de documentación de Términos y Condiciones por orden de compra y sociedad",
          link: "/lista-terminos-condiciones",
          key: "termCondUsuario",
        },
        /*  {
          title: "Facturas",
          action: "ic_invoice",
          descripcion:
            "Recepción de documentación por factura por orden de compra",
          link: "/lista-factura",
          key: "docFactUsuario",
        }, */
        {
          title: "Reportes",
          action: "clipboard-file",
          descripcion: "Genera y visualiza los reportes",
          link: "/reportes",
          key: "repUsuario",
        },
      ],
    };
  },
  methods: {},
});
